import styled from 'styled-components';
import { newColors } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
export const Label = styled.div `
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${newColors.purple500};
  font-weight: medium;
  line-height: 18px;
  width: fit-content;

  ${mediaq.lg `
max-width: ${(props) => (props.length === 5 || props.length <= 4 ? '100%' : '60%')};
`}

  ${mediaq.md `
max-width: ${(props) => (props.length > 4 ? '60%' : '100%')};
`}


${mediaq.sm `
max-width: 100%;
`}
`;
export const ButtonWrapper = styled.button `
display: flex;
width: 100%;
justify-content: center;
align-items: center;
flex-direction: ${(props) => (props.length > 4 ? 'column' : 'row')};
gap: 12px;
cursor: pointer;
border: 0px;
border-right: ${(props) => props.displayRightBorder ? `1px solid ${newColors.gray100}` : 'none'};
  background-color: ${newColors.snow};
  padding: 12px;

  &:hover {
    > div:first-child {
      background-color: ${newColors.purple200};
    }
    > div:nth-child(2) {
      color: ${newColors.gray800};
    }
  }

  ${mediaq.lg `
flex-direction: ${(props) => (props.length > 3 ? 'column' : 'row')};
`}

  ${mediaq.md `
flex-direction: ${(props) => (props.length > 2 ? 'column' : 'row')};
`}

${mediaq.sm `
width: 100%;
flex-direction: row-reverse;
justify-content: space-between;
`}
`;
export const CircleIcon = styled.div `
  flex-shrink: 0;
  background-color: ${newColors.purple100};
  width: ${(props) => props.size || 60}px;
  height: ${(props) => props.size || 60}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaq.md `
width: 56px;
height: 56px;
`}

  ${mediaq.sm `
margin-bottom: 0px;
width: 46px;
height: 46px;
* > svg {
transform: scale(.8);
}
`}
`;
